import styled from 'styled-components';
import HeroSection from '../sections/HeroSection';
import ServicesSection from '../sections/ServicesSection';
import CaseStudySection from '../sections/CaseStudySection';
import PricingSection from '../sections/PricingSection';
import BlogSection from '../sections/BlogSection';
import FaqSection from '../sections/FaqSection';

/* ────────── layout wrapper ────────── */
// Removed scroll‑snap and fixed‑height behaviour to allow
// natural scrolling on both mobile and desktop.
const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  // gap: 4rem;
  width: 100%;
  

  

  /* Roomier rhythm on larger breakpoints */
  @media (min-width: 768px) {
    // gap: 6rem;
  }
`;

export default function LandingPage() {
  return (
    <>
      <Wrapper>
        <HeroSection />
        <ServicesSection />
        <CaseStudySection />
        <PricingSection />
        <BlogSection />
        <FaqSection />
      </Wrapper>
    </>
  );
}
